// funciones para paginado server side
verifyCollection();
loadProducts(localStorage.actualPage);
scrollToProductFromLocalStorage();

function verifyCollection() {
  const url_ = window.location.pathname;
  const urlSplit = url_.split("?");
  let urlCollection = urlSplit[0];
  if (localStorage.actualCollection !== urlCollection) {
    localStorage.actualPage = 1;
  }
}

function scrollToProductFromLocalStorage() {
  var productID = localStorage.productID;
  if (productID != null) {
    
    let navigationHistory = JSON.parse(localStorage.getItem('@history') || '[]');
    let currentPath = window.location.pathname;
    
    
    let lastPage = navigationHistory[navigationHistory.length - 1];
    let previousPage = navigationHistory[navigationHistory.length - 2];
    
    
    if (lastPage && previousPage) {
      let isComingFromProduct = lastPage.includes('/products/');
      let isReturningSameCollection = previousPage === currentPath;
      
      if (!isComingFromProduct || !isReturningSameCollection) {
        localStorage.removeItem('productID'); // Limpiar el productID si no cumple las condiciones
        return;
      }
    }

    let element_ = document.getElementById(`current_variant_id_${productID}`);
    if (element_) {
      element_.scrollIntoView({ block: "center" });
      // buscar order by en url
      var url_ = getCurrentURL();
      var urlSplit_ = url_.split('?');
      if (urlSplit_[1] !== undefined) {
        var urlQueryParameters_ = urlSplit_[1].split('&');
        if (urlQueryParameters_.length > 0) {
          urlQueryParameters_.forEach(element => {
            if (element.includes(`sort_by`)) {
              let sortBy_ = element.split('=');
              if (sortBy_[1] !== undefined) {
                let sortByElement_ = document.getElementById('sort_by_id');
                if (sortByElement_) {
                  sortByElement_.value = sortBy_[1];
                }
              }
            }
          });
        }
      }
    } else {
      console.log(`Element not found: ${productID}`);
    }
  }
}

function getCurrentURL () {
  return window.location.href
}

function getProductsTotals(newProducts, newPagination, productsCounterTotal) {
  var counterTotalProducts = newProducts.querySelectorAll(".product-item a").length;
  var allPages     = newPagination.querySelectorAll(".bold-active span");
  var defaultPage_ = 1;
  if (allPages[0] != undefined) {
    defaultPage_ = parseInt(allPages[0].innerHTML); 
  }    
  // TODO_REFACTOR => no usar este dato de page size como estático.
  var defaultPageSize_ = 30;
  var prod_by_page = document.getElementById('prod_by_page');
  if (prod_by_page) {
    defaultPageSize_ = parseInt(prod_by_page.value);
  }

  var text_ = `${defaultPageSize_*(defaultPage_-1) + 1} - ${defaultPageSize_*(defaultPage_-1) + counterTotalProducts}`;
  document.getElementById('products-counter').innerHTML = text_;
  if (productsCounterTotal) {
    document.getElementById('products-counter-total').innerHTML = productsCounterTotal.innerHTML;
  }
}

function loadProducts(actualPage = null) {
  if (actualPage != null) {
    var url = getCurrentURL();
    // url += '?page=' + actualPage;
    showLoaderGift();
    fetch(url)
      .then(response => response.text())
      .then(html => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newProducts = doc.querySelector('#product-list').innerHTML;
        var newPagination = doc.querySelector('#pagination-controls').innerHTML;
        document.querySelector('#product-list').innerHTML = newProducts;
        document.querySelector('#pagination-controls').innerHTML = newPagination;
        getProductsTotals(doc.querySelector('#product-list'), doc.querySelector('#pagination-controls'));
        printPaginationCounters(doc, 'product1');
        loadProducts();
        scrollToProductFromLocalStorage();
        showLoaderGift(false);
      });
  } else {
    document.querySelectorAll('#pagination-controls a').forEach(function (paginationLink) {
      paginationLink.addEventListener('click', function (event) {
        event.preventDefault();
        var url = this.href;
        const url_ = window.location.pathname;
        const urlSplit = url_.split("?");
        let urlCollection = urlSplit[0];
        localStorage.actualCollection = urlCollection;
        localStorage.actualPage = this.textContent;
        addPageToUrl('page', localStorage.actualPage, url);
        showLoaderGift();
        fetch(url)
          .then(response => response.text())
          .then(html => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newProducts = doc.querySelector('#product-list').innerHTML;
            var newPagination = doc.querySelector('#pagination-controls').innerHTML;
            document.querySelector('#product-list').innerHTML = newProducts;
            document.querySelector('#pagination-controls').innerHTML = newPagination;
            getProductsTotals(doc.querySelector('#product-list'), doc.querySelector('#pagination-controls'));
            printPaginationCounters(doc, 'product2');
            loadProducts();
            showLoaderGift(false);
          });
        scrollToTopDiv();
      });
    });
  }
}

function addPageToUrl(key, value, url_) {
  var urlSplit_          = url_.split('?');
  var newQueryParameter_ = `?${key}=${value}`;
  if (urlSplit_[1] !== undefined) {
    var urlQueryParameters_ = urlSplit_[1].split('&');
    if (urlQueryParameters_.length > 0) {
      newQueryParameter_ = ``;
      urlQueryParameters_.forEach(element => {
        let keyValueToAdd_ = element;
        if (element.includes(`${key}=`)) {
          keyValueToAdd_ = `${key}=${value}`;
        }
        if (element.includes(`sort_by`)) {
          let sortBy_ = element.split('=');
          if (sortBy_[1] !== undefined) {
            let sortByElement_ = document.getElementById('sort_by_id');
            if (sortByElement_) {
              sortByElement_.value = sortBy_[1];
            }
          }
        }
        newQueryParameter_ += `&${keyValueToAdd_}`;
      });
    }
  }
  window.history.replaceState(null, null, `?${newQueryParameter_}`);
}

function showLoaderGift(show = true, landing = false) {
  var loaderGif = document.getElementById('loader-gif');
  if (loaderGif) {
    if (show) {
        loaderGif.classList.add('show');
        if (landing) {
          loaderGif.classList.add('landing-loader');
        }
    } else {
        loaderGif.classList.remove('show');
        if (landing) {
          loaderGif.classList.add('display-none');
        } else {
          let showReviews = document.getElementById('showReviewsInput');
          if (showReviews && parseInt(showReviews.value) === 1) {
            observeElementsPLPAndSLP();
          }
        }
    }
  }
}

function scrollToTopDiv(loaderGif = null) {
  let scrollToTopDiv = document.getElementById('scrollToTopDiv');
  if (scrollToTopDiv) {
    scrollToTopDiv.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    if (loaderGif != null) {
      loaderGif.classList.remove('show');
    }
  }
}

function printPaginationCounters(doc, insigth_) {
  // counters
  const productsPerPage = doc.querySelectorAll(".product-item").length;
  const productCounter = doc.querySelector("#products-counter");
  const productsCounterTotal = doc.querySelector("#products-counter-total");
  // set counters
  getProductsTotals(doc.querySelector('#product-list'), doc.querySelector('#pagination-controls'), productsCounterTotal);
}